import getEventPath from "./getEventPath";
import isIe11 from "./isIe11";
export default {
  getEventPath: getEventPath,
  isIe11: isIe11
};